import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CoreModule } from './modules/core/core.module';

import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UiModule } from './modules/ui/ui.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { httpInterceptorProviders } from './interceptors';
import { LoggingSetupDialogComponent } from './components/logging-setup-dialog/logging-setup-dialog.component';
import { environment as env } from '../environments/environment';
import { VerifyLoginTokenComponent } from './components/verify-login-token/verify-login-token.component';
import { SignupConfirmationComponent } from './components/signup-confirmation/signup-confirmation.component';
import { VerifyAccountComponent } from './components/verify-account/verify-account.component';
import { SignupComponent } from './components/signup/signup.component';
import { TisClientSideDropdownComponent, TisSearchAndSelectDropdownModule } from '@servicemind.tis/tis-search-and-select-dropdown';
import { ConfirmationPopupComponent } from './components/login/confirmation-popup/confirmation-popup.component';


@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        NotFoundComponent,
        ResetPasswordComponent,
        LoggingSetupDialogComponent,
        VerifyLoginTokenComponent,
        SignupComponent,
        SignupConfirmationComponent,
        VerifyAccountComponent,
        ConfirmationPopupComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: env.production || env.stage,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        UiModule,
        TranslocoRootModule,
        TisSearchAndSelectDropdownModule
    ], 
    providers: [httpInterceptorProviders, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }

